export const AUTH_FORM_ID = "auth-token-form";
export var Action;
(function (Action) {
    Action["CANCEL"] = "cancel";
    Action["SUCCESSFUL_SAVE"] = "successfulSave";
    Action["RESIZE_WINDOW"] = "resizeWindow";
})(Action || (Action = {}));
export var MODE;
(function (MODE) {
    MODE["EDIT"] = "edit";
    MODE["ADD"] = "add";
})(MODE || (MODE = {}));
